import React from 'react'
import { Helmet } from 'react-helmet'

import { getCommonLDScripts } from '../../services/seo'

import { useBrowserTab } from '../../hooks/useBrowserTab'

import DeliveryImg from '../../icons/dostavka.png'

import './delivery.css'

const Delivery = () => {
  useBrowserTab({ tabName: 'Доставка' })

  return (
    <>
    <Helmet script={getCommonLDScripts()}>
      <meta name='author' content='Xpart' />
      <meta name="robots" content="index,follow" />
      <meta name='theme-color' content='#1a7fc8' />
      <meta name='local' property='og:local' content='uk_UA' />
      <meta name='site_name' property='og:site_name' content={window.location.hostname} />
    </Helmet>
    <div className='page__delivery'>
      <section className='delivery'>
        <div className='section__content flex-container'>
          <div className='delivery__left'>
            <div className='delivery__title'>Доставка</div>
            <img src={DeliveryImg} alt='delivery' />  
          </div>
          <div className='delivery__description'>
            <div className='delivery__description__title'>
              Шановні клієнти ми приймаємо замовлення тільки через сайт і з номерами, вказаними на сайті.
            </div>
            <p></p>
            <div className='delivery__description__sub-title'>Доставка та оплата по Україні:</div>
            <div>по Україні доставка товару відбувається кур'єрською службою Нова пошта;</div>
            <div>відправка замовлення через транспортну компанію здійснюється два раза в тиждень (серед і субботу);</div>
            <div>доставку товару новой пошті оплачує покупець;</div>
            <div>товар, придбаний у нас, страхується на новій пошті на сумі рівноцінної його вартості, тому при отриманні товару одержувач повинен перевірити його безпосередньо в відділенні транспортної компанії. Якщо будуть виявлені пошкодження, які виникли під час доставки замовлення, тоді потрібно скласти акт прийому-передачі та оформити претензію (без цих документів не виплатять компенсацію за пошкоджений товар);</div>
            <p></p>
            <div className='delivery__description__sub-title'>Сроки доставки:</div>
            <div>весь процес доставки займає від 3-х до 7-и робочих днів!</div>
            <p></p>
            <p>Доставка автозапчастин здійснюється тільки <span className='delivery__description__sub-title'>після повної або часткової оплаты за розміром 50% від вартості.</span></p>
          </div>
        </div>
        <div></div>
      </section>

      <section className='payment-methods'>
        <div className='section__content'>
          <div className='payment-methods__title'>Способи оплати</div>
          <ul>
            <li>На карту приват банка</li>
            <li>На розрахунковий рахунок компанії</li>
            <li>Платіжними картками Visa чи Mastercard у нас на сайті через систему Liqpay чи Interkassa.</li>
          </ul>
        </div>
      </section>

      <section>
        <div className='section__content goods__return'>
          <p>У Польщі, згідно із законодавством, споживач має право повернути НОВИЙ товар протягом 14 днів з моменту його придбання, якщо товар не має видимих ​​слідів пошкодження, розбору або неакуратного обігу. Таким чином, з урахуванням термінів доставки запчастини в Україну та безпосередньо до Вас, термін на перевірку та встановлення запчастини залишається не більше 5-ти днів. На Б/У запчастини дається тільки перевірна гарантія та їх повернення чи обмін можливі лише у випадках коли:</p>
          <p></p>
          <p>- запчастина несправна або працює неправильно;</p>
          <p>- запчастина має суттєві пошкодження, яких не було вказано на фотографіях лота;</p>
          <p>- Запчати прийшла не та, що була вказана в оголошенні;</p>
          <p>- було обговорено індивідуальні умови гарантії (повернення).</p>
          <p>Перевірна гарантія на Б/У запчастини становить 5 робочих днів, за умови, що її продавець так само дає від себе гарантію на перевірку.</p>
        </div>
      </section>
    </div>
    </>
  )
}

export default Delivery
